var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 4.13333C2.66663 4.0597 2.72632 4 2.79996 4H3.53329C3.60693 4 3.66663 4.0597 3.66663 4.13333V4.86667C3.66663 4.9403 3.60693 5 3.53329 5H2.79996C2.72632 5 2.66663 4.9403 2.66663 4.86667V4.13333Z",
    fill: "#A3A5B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3997 4.13333C4.3997 4.0597 4.45939 4 4.53303 4H13.8664C13.94 4 13.9997 4.0597 13.9997 4.13333V4.86667C13.9997 4.9403 13.94 5 13.8664 5H4.53303C4.45939 5 4.3997 4.9403 4.3997 4.86667V4.13333Z",
    fill: "#A3A5B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 6.46667C2.66663 6.39303 2.72632 6.33333 2.79996 6.33333H3.53329C3.60693 6.33333 3.66663 6.39303 3.66663 6.46667V7.2C3.66663 7.27364 3.60693 7.33333 3.53329 7.33333H2.79996C2.72632 7.33333 2.66663 7.27364 2.66663 7.2V6.46667Z",
    fill: "#A3A5B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3997 6.46667C4.3997 6.39303 4.45939 6.33333 4.53303 6.33333H13.8664C13.94 6.33333 13.9997 6.39303 13.9997 6.46667V7.2C13.9997 7.27364 13.94 7.33333 13.8664 7.33333H4.53303C4.45939 7.33333 4.3997 7.27364 4.3997 7.2V6.46667Z",
    fill: "#A3A5B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 8.8C2.66663 8.72636 2.72632 8.66667 2.79996 8.66667H3.53329C3.60693 8.66667 3.66663 8.72636 3.66663 8.8V9.53333C3.66663 9.60697 3.60693 9.66667 3.53329 9.66667H2.79996C2.72632 9.66667 2.66663 9.60697 2.66663 9.53333V8.8Z",
    fill: "#A3A5B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3997 8.8C4.3997 8.72636 4.45939 8.66667 4.53303 8.66667H13.8664C13.94 8.66667 13.9997 8.72636 13.9997 8.8V9.53333C13.9997 9.60697 13.94 9.66667 13.8664 9.66667H4.53303C4.45939 9.66667 4.3997 9.60697 4.3997 9.53333V8.8Z",
    fill: "#A3A5B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 11.1333C2.66663 11.0597 2.72632 11 2.79996 11H3.53329C3.60693 11 3.66663 11.0597 3.66663 11.1333V11.8667C3.66663 11.9403 3.60693 12 3.53329 12H2.79996C2.72632 12 2.66663 11.9403 2.66663 11.8667V11.1333Z",
    fill: "#A3A5B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3997 11.1333C4.3997 11.0597 4.45939 11 4.53303 11H13.8664C13.94 11 13.9997 11.0597 13.9997 11.1333V11.8667C13.9997 11.9403 13.94 12 13.8664 12H4.53303C4.45939 12 4.3997 11.9403 4.3997 11.8667V11.1333Z",
    fill: "#A3A5B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.4e9d4ec46b44980f94f39e1e264d6373.svg";
export { ForwardRef as ReactComponent };